<app-modal
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  (onHidden)="onHiddenInternal()"
  [closeOutsideClickEnabled]="false"
  modalTitle="{{ bufferText }}"
  width="25rem"
  height="auto"
>
  <ng-template modalContent>
    <form class="form" [formGroup]="formGroup" (ngSubmit)="onSubmit($event)">
      <div class="fields-container">
        <div class="field-set">
          <label label>{{ distanceMetersText }}</label>

          <app-input-box
            class="input"
            type="number"
            formControlName="distanceInMeters"
            [min]="0"
            [showClearButton]="false"
            [showErrorEnabled]="false"
          ></app-input-box>

        </div>

        <div class="field-set">
          <label label>{{ colorText }}</label>

          <app-input-color-box
            formControlName="color"
            [showClearButton]="false"
            [showErrorEnabled]="false"
          >
          </app-input-color-box>
        </div>

        <div class="field-set">
          <label label>{{ transparencyText }}</label>

          <app-range-slider
            class="range-slider"
            formControlName="opacity"
            [min]="0"
            [max]="1"
            [step]="0.01"
          ></app-range-slider>
        </div>
      </div>

      <div class="actions-bottom">
        <app-button
          buttonType="normal"
          styleType="contained"
          text="{{ cancelText }}"
          (click)="onBtnCancelClick()"
        ></app-button>

        <app-button
          type="submit"
          buttonType="primary"
          styleType="contained"
          text="{{ applyText }}"
          [disabled]="formGroup.invalid"
        ></app-button>
      </div>
    </form>
  </ng-template>
</app-modal>
